<template>
  <div id="app">
    <Header v-if="isShow"></Header>
    <router-view :key="$route.fullPath" />

    <Footer v-if="isShow"></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
  import store from "@/store";
  export default {
    name: 'App',

    data() {
      return {
        isShow: true
      };
    },
    created() {
      this.isShow = isHref();
    },

    mounted() {
      var news = localStorage.getItem('SET_NAVS')
      var newsActive = localStorage.getItem('SET_NAVS_ACTIVE')
      store.commit("SET_NAVS", isNull(news) ? news : 0)
      store.commit("SET_NAVS_ACTIVE", isNull(newsActive) ? newsActive : 0)
      var user = localStorage.getItem('SET_USER')
      var token = localStorage.getItem('SET_TOKEN');
      store.commit("SET_TOKEN", isNull(token) ? token : '')
      store.commit("SET_USER", isNull(user) ? JSON.parse(user) : null)



    }
  }

  function isNull(item) {
    if (item != null && item != "" && item != NaN && item != undefined) {
      return true
    } else {
      return false
    }
  }


  function isHref() {
    var url = window.location.href
    if (url.indexOf('MeetingPage') != -1) {
      return false
    }
    return true
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/App.vue